import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=dd77f60e&scoped=true&lang=pug"
import script from "./CustomerData.vue?vue&type=script&lang=js"
export * from "./CustomerData.vue?vue&type=script&lang=js"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=dd77f60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd77f60e",
  null
  
)

export default component.exports